var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trade-mining-section shadow" },
    [
      _c(
        "div",
        { staticClass: "staking-detail" },
        _vm._l(["dSLS", "BTC", "ETH", "USDT"], function(tokenType) {
          return _c("div", { key: tokenType, staticClass: "item" }, [
            _c("div", [
              _vm._v(
                _vm._s(tokenType) + " " + _vm._s(_vm.$t("tradeMining.fee"))
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bold" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.expectedDividends && _vm.expectedDividends[tokenType]
                      ? _vm.expectedDividends[tokenType].fee
                      : 0
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "light" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("tradeMining.dividends")))]),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.expectedDividends && _vm.expectedDividends[tokenType]
                      ? _vm.expectedDividends[tokenType].dividend
                      : 0
                  ) +
                  "dSLS\n            "
              )
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "wallet-table",
        {
          staticClass: "mint-trade-table no-shadow tb",
          attrs: { headList: _vm.tradeHeadList, contentList: _vm.content }
        },
        [
          _c("pagination", {
            staticClass: "__tb_pagination",
            attrs: {
              slot: "tableBottom",
              currentPage: _vm.tradeCurrentPage + 1,
              toPage: _vm.fetchMiningTrade,
              totalPage: _vm.tradeTotalPage
            },
            slot: "tableBottom"
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }